import React, { useEffect, useState } from "react";
import Base from '../../utils/base'
import moment from "moment";

export default function Header(props) {
  var base = new Base()
  const momentNow = moment()
  const [infoData, setInfoData] = useState({})

  useEffect(() => {
      get_info_data()
    }, [])
  
    async function get_info_data() {
      var response = await base.request(base.url_api + "/info?type=room")
  
      if(response != null){
        if(response.status == "success"){
          setInfoData(response.data)
        }
        else
          base.show_error(response.message)
      }
      else
        console.log('Server Error')
    }

  return (
    <section class="page-header">
      <div class="page-header__bg" style={{ backgroundImage: "url(" + infoData.url_image1 + ")", }}></div>
      <div class="container">
        {/* <img src="assets/images/shapes/page-header-s-1.png" alt="Room Grid" class="page-header__shape" /> */}
        <h2 class="page-header__title" style={{ fontSize: '2.5rem', }}>{infoData.title}</h2>
        {/* <ul class="solinom-breadcrumb list-unstyled">
          <li><a href="index.html">Home</a></li>
          <li><span>Room</span></li>
        </ul> */}
      </div>
    </section>
  );
};
